<template>
  <div class="container commonDetail">
    <el-breadcrumb separator="/">
      <el-breadcrumb-item :to="{ path: '/Mine/ObtainEvidence' }">取证列表</el-breadcrumb-item>
      <el-breadcrumb-item>取证详情</el-breadcrumb-item>
    </el-breadcrumb>
    <div
      class="commonWhiteBg"
      v-if="orderInfo"
    >
      <div class="topSteps">
          <el-steps :active="orderInfo.step">
          <el-step title="支付">
            <div slot="description">
              {{orderInfo.status=='10'?'等待支付':paymentInfo.payTimeText}}
            </div>
            <a-icon
              v-if="orderInfo.status!='10'"
              slot="icon"
              type="check"
            />
            <a-icon
              v-else
              slot="icon"
              type="redo"
            />
          </el-step>
          <el-step title="上链">
            <template v-if="orderInfo.status=='10'">
              <div slot="description"> 取证上链 </div>
              <a-icon
                slot="icon"
                type="exclamation"
              />
            </template>
            <template v-else-if="orderInfo.status=='11'">
              <div slot="description"> 处理中，请耐心等待</div>
              <a-icon
                slot="icon"
                type="redo"
              />
            </template>
            <template v-else-if="orderInfo.status=='13'||orderInfo.status=='21'">
              <div slot="description"> {{orderInfo.chainTimeText}}</div>
              <a-icon
                slot="icon"
                type="check"
              />
            </template>
          </el-step>
          <el-step title="取证证书">
           
            <template v-if="orderInfo.status=='21'">
              <div slot="description"> {{orderInfo.updateTimeText}}</div>
              <a-icon
                slot="icon"
                type="check"
              />
            </template>
               <template v-else>
              <div slot="description"> 取证成功，获得证书 </div>
              <a-icon
                slot="icon"
                type="exclamation"
              />
            </template>

          </el-step>
        </el-steps>
        <div class="rightMain">
          <div>
            <div> <span class="label"> 订单编号：</span> <span class="value"> {{orderNo}} </span> </div>
            <div> <span class="label"> 支付方式：</span> <span class="value"> {{orderInfo.paymodeText}}（{{orderInfo.orderAmount}}元）</span> </div>
          </div>
          <!-- <div>
            <span class="label"> 支付方式：</span>
            <span class="value"> 会员次数</span>
          </div> -->
          <div
            class="btnWrap"
            v-if="orderInfo.status=='10'"
          >
            <el-button
              type="primary"
              size="mini"
              @click="onGoPay"
            >立即支付</el-button>
          </div>
        </div>
      </div>

      <div
        class="pdfShow"
        v-if="orderInfo.status=='21'"
      >
        <div>
          <div class="commonTitle">取证证书</div>
          <p class="tittle">温馨提示：</p>
          <p class="desc">
            1、使用中国知链微信小程序，扫描二维码可查验证书真伪；<br />
            2、通过中国知链防伪查询网址可查验真伪。<br />
          </p>
          <div class="btnWrap">
            <el-button
              type="primary"
              size="mini" @click="downloadCertificate"
            >下载存证证书</el-button>
          </div>
        </div>
        <div>
          <el-image
            class="img"
            v-if="orderInfo.certificateInfo"
            :src="orderInfo.certificateInfo.jpgUrl"
            :preview-src-list="[orderInfo.certificateInfo.jpgUrl]"
          >
          </el-image>
        </div>
        <!-- <div>
          <img
            src="https://ipchain.oss-cn-hangzhou.aliyuncs.com/web/useless/zhenshu.png"
            class="img"
          />
        </div> -->
      </div>

      <div class="commonTitle mt32">取证信息</div>
      <div>
        <el-form
          ref="form"
          :model="form"
          label-width="140px"
        >
          <el-form-item
            label="存证文件"
            prop="evidenceFile"
          >
            <div class="nameRow">
              <span 
                v-for="(file, index) in orderInfo.items"
                v-if="file.itemType=='1'"
                :key="index"
              >
                {{ file.sourceName }} &nbsp;
              </span>
              <router-link :to="{ path: '/ExistingEvidence/FileList', query: {orderNo:orderNo,bizType:'obtain',itemType:'1'} }">
                查看存证文件
              </router-link>
            </div>
          </el-form-item>
          <el-form-item
            label="取证名称"
            prop="name"
          >
            <div class="nameRow">
              {{ orderInfo.subject }}
              <!-- <router-link :to="{ path: '/ExistingEvidence/FileList', query: {} }">
                查看存证文件
              </router-link> -->
            </div>
          </el-form-item>
          <el-form-item
            label="取证相关描述"
            prop="remark"
            v-if="orderInfo.remark"
          >
            <el-input
              v-model="orderInfo.remark"
              :rows="4"
              disabled
              placeholder=""
              type="textarea"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="存证数据包校验值"
            prop="value2"
          >
            {{
              orderInfo.certificateInfo
                ? orderInfo.certificateInfo.body.data.md5Code
                : "-"
            }}
            <router-link
              class="ml16"
              :to="{ path: '/ExistingEvidence/FileList', query: {orderNo:orderNo,bizType:'obtain',itemType:'1'} }"
            >
              查看
            </router-link>
          </el-form-item>
          <el-form-item
            label="校验算法"
            prop="value4"
          >
            {{ form.value4 }}
          </el-form-item>
          <el-form-item
            label="取证数量"
            prop="value3"
          >
            {{ orderInfo.items.filter(t=>t.itemType=='2').length }} 
            个文件
            <router-link
              class="ml16"
              :to="{ path: '/ExistingEvidence/FileList', query: {orderNo:orderNo,bizType:'obtain',itemType:'2'} }"
            >
              查看
            </router-link>
          </el-form-item>
          <el-form-item
            label="订单编号"
            prop="value5"
          >
            {{ orderInfo.orderNo }}
          </el-form-item>
          <el-form-item
            label="提交取证时间"
            prop="value7"
          >
            {{ orderInfo.createTimeText }}
          </el-form-item>
          <el-form-item
            label="取证证书下发时间"
            prop="value6"
          >
            {{orderInfo.updateTimeText}}
          </el-form-item>
          <el-form-item label="支付方式" prop="value6">
            {{ orderInfo.paymodeText }}
          </el-form-item>
          <el-form-item label="支付金额（元）" prop="value7">
            {{ orderInfo.orderAmount }}
          </el-form-item>
        </el-form>
      </div>
    </div>

     <pay-dialog ref="payDialog" @close="onSetPayDialogClose"></pay-dialog>
  </div>
</template>

<script>
import { queryObtainOrder,paymentObtainOrder } from "@/api/ObtainEvidence";
import {
  queryPaymentOrderByOutBizNp
} from "@/api/EvidenceService";
import constants from '@/utils/constants'
import PayDialog from "@/views/multipleService/components/PayDialog";
import multipleSelect from "../../../components/form/multipleSelect";
export default {
  name: "ObtainEvidenceDetail",
  components: { multipleSelect,PayDialog },
  data () {
    return {
      stepIdx: 3, // 0 带支付, 1处理中,3 完成
      orderNo: this.$route.query.orderNo,
      orderInfo: {
        items:[]
      },
      paymentInfo: {},
      form: {
        evidenceFile: "作品名称123",
        name: "取证名称123",
        remark:
          "作者进行文学艺术创作的目的、计划或打算。不论是已经形成明确的思想,或是模糊的情感意向,总是和作者对自己作品的态度、看法、创作的动因有着明显的联系。是影响创作的一个重要因素,但作品的主题或意义不能完全依据它来",
        value2: "-",
        value3: "1",
        value4: "MD5",
        value5: "12837127907017979",
        value6: "-",
        value7: "-",
      },
    };
  },
  created() {
    this.loadData();
  },
  methods: {
    getStep (status) {
      let step = 0;
      if (status == "10") {
        step = 0;
      } else if (status * 1 < 15) {
        step = 1;
      } else {
        step = 2;
      }
      return step;
    },
    downloadCertificate() {
      window.open(this.orderInfo.certificateInfo.pdfUrl);
    },
    loadData () {
      queryObtainOrder(this.orderNo).then(({ data }) => {
        this.orderInfo = data;
        console.log(constants);
        this.orderInfo.createTimeText = this.dayjs(
          this.orderInfo.createTime * 1000
        ).format("YYYY-MM-DD HH:mm:ss ");
        this.orderInfo.updateTimeText = this.dayjs(
          this.orderInfo.updateTime * 1000
        ).format("YYYY-MM-DD HH:mm:ss ");
        this.orderInfo.paymodeText = constants.paymode[this.orderInfo.paymode];
        this.orderInfo.step = this.getStep(this.orderInfo.status);
        if (this.orderInfo.status != "10") {
          queryPaymentOrderByOutBizNp(this.orderNo, "3").then(({ data }) => {
            this.paymentInfo = data;
            this.paymentInfo.payTimeText = this.dayjs(
              this.paymentInfo.updateTime * 1000
            ).format("YYYY-MM-DD HH:mm:ss ");
          });
        }
        if(this.orderInfo.status!='21'){
            this.timer = setTimeout(this.loadData,30*1000);
        }
      });
    },
     onGoPay() {
      let that = this;
      paymentObtainOrder(that.orderNo).then(({data})=>{
            that.$refs.payDialog.showDialog(data);
            that.isPayDialogVisible = true;
      })
    
    },
    onSetPayDialogClose(result) {
      console.log(result);
      if (result) {
        this.loadData();
      }
    },
  },
  beforeDestroy() { // Vue 2.x
    clearTimeout(this.timer);
  },
};
</script>

<style lang='scss' scoped>
@import '../../../assets/css/inputForm.scss';
</style>
